import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaCorreta = (): TabelaColuna => ({
  Chave: 'correta',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 70 }}>Correta</div>
})
